var firebaseConfig = {
    apiKey: "AIzaSyCrM-pselcYHz8dhojDnNSpjA7thmKJPIg",
    authDomain: "pickup-ffaa3.firebaseapp.com",
    projectId: "pickup-ffaa3",
    storageBucket: "pickup-ffaa3.appspot.com",
    messagingSenderId: "968955676772",
    appId: "1:968955676772:web:34388ff0738689e8ca3771",
    measurementId: "G-VM2DBVNFD2"
  };

export default firebaseConfig;